import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import SearchBarContainer from './SearchBarContainer';
import { clearCarrierAndPlan, setCarrier, setPlan } from '../../../InsurancePicker/data/dropdown-state/dropdownStateActions';
import { fetchCarriersIfNeeded } from '../../../InsuranceForm/carriers';
import { fetchPlansIfNeeded } from '../../../InsuranceForm/plans';
import { selectCarrier } from '../../../InsurancePicker/data/carrier';
import { selectPlan } from '../../../InsurancePicker/data/plan/planActions';
import { setInsuranceType } from '../../../InsurancePicker/';
import {
    trackPpsChange,
    trackPpsFocus,
    trackPpsSelect,
} from './SearchBarActions';

const mapDispatchToProps = {
    clearCarrierAndPlan,
    fetchCarriersIfNeeded,
    fetchPlansIfNeeded,
    selectCarrier,
    selectPlan,
    setCarrier,
    setInsuranceType,
    setPlan,
    trackPpsChange,
    trackPpsFocus,
    trackPpsSelect,
};

export default withTheme(connect(undefined, mapDispatchToProps)(SearchBarContainer));
